import * as React from "react";

export const MediaScrollButton = (): React.ReactElement => (
    <svg
        width={28}
        height={16}
        viewBox="0 0 28 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M24.59 0.59C25.37 -0.20 26.63 -0.20 27.41 0.59C28.20 1.37 28.20 2.63 27.41 3.41L15.41 15.41C14.63 16.20 13.37 16.20 12.59 15.41L0.59 3.41C-0.20 2.63 -0.20 1.37 0.59 0.59C1.37 -0.20 2.63 -0.20 3.41 0.59L14 11.17L24.59 0.59Z"
            fill="white"
        />
    </svg>
);
